export enum Languages
{
    English = 1,
    Arabic = 2
}